import { formatTag } from '@/search-for-retail/tag/tag.formatters';
import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
/** Path for the tag resource. */
const TAG_PATH = 'admin/tag';
/**
 * RTK Query endpoints for tag data.
 *
 * This module extends the base ccApi with tag query and mutation endpoints.
 *
 * @see https://redux-toolkit.js.org/rtk-query/api/created-api/code-splitting
 */
export const tagApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        /**
         * Fetches the list of all tags.
         *
         * @endpoint GET /admin/tag
         * @returns Tag[]
         */
        getTagList: builder.query({
            query: () => `/${TAG_PATH}`,
            providesTags: [CC_API_TAGS.TagList],
        }),
        /**
         * Fetches a single tag by ID.
         *
         * @endpoint GET /admin/tag/{id}
         * @returns Tag
         */
        getTagById: builder.query({
            query: ({ id }) => `/${TAG_PATH}/${id}`,
            providesTags: (_result, _error, { id }) => [{ type: CC_API_TAGS.Tag, id }],
        }),
        /**
         * Creates a new tag.
         *
         * @endpoint POST /admin/tag
         * @returns The created Tag
         */
        createTag: builder.mutation({
            query: ({ data }) => ({
                url: `/${TAG_PATH}`,
                method: 'POST',
                body: formatTag(data),
            }),
            invalidatesTags: [CC_API_TAGS.TagList],
        }),
        /**
         * Updates an existing tag.
         *
         * @endpoint PUT /admin/tag/{id}
         * @returns The updated Tag
         */
        updateTag: builder.mutation({
            query: ({ data }) => ({
                url: `/${TAG_PATH}/${data.id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: (_result, _error, { data }) => [
                CC_API_TAGS.TagList,
                { type: CC_API_TAGS.Tag, id: data.id },
            ],
        }),
        /**
         * Deletes a tag by ID.
         *
         * @endpoint DELETE /admin/tag/{id}
         */
        deleteTag: builder.mutation({
            query: ({ id }) => ({
                url: `/${TAG_PATH}/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (_result, _error, { id }) => [
                CC_API_TAGS.TagList,
                { type: CC_API_TAGS.Tag, id },
            ],
        }),
    }),
});
export const { useGetTagListQuery, useGetTagByIdQuery, useCreateTagMutation, useUpdateTagMutation, useDeleteTagMutation, } = tagApi;
